import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CommonService } from 'src/app/services/common.service';
import { debounceTime, filter, take, takeUntil } from 'rxjs/operators';
import { v4 as uuidv4 } from "uuid";
import moment from 'moment';
import { ConfigComponent } from 'src/app/config/config.component';
import { Router } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { NewauditComponent } from '../../newaudit/newaudit.component';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule ,FormBuilder} from '@angular/forms';
import { TabChangeService } from 'src/app/services/tab-change.service';
import { ModalTabVisibilityService } from '../../services/modal-tab-visibility.service';
declare const copyToClipboard: any;
@Component({
  selector: 'app-agent',
  templateUrl: './agent.component.html',
  styleUrls: ['./agent.component.scss']

})
export class AgentComponent implements OnInit, OnDestroy {
  reactiveFormagent: FormGroup;
  reactiveFormagenttypedl: FormGroup;
  reactiveFormagentstatustype: FormGroup;
  reactiveFormmodetype: FormGroup;
  reactiveFormagentstagetype: FormGroup;
  reactiveFormmodeagent: FormGroup;
  reactiveFormtypeagent: FormGroup;
  reactiveFormtypepipeline: FormGroup;


  keywordsearch = "displayname";
  isLoadingagent: boolean = false;
  AgentNameList: any[];
  notfounddata: boolean;
  isLoadingpa: boolean;
  selectedAgentguid: string;
  selectedAgentName: any;
  agenttype = 'Select';
  agenttypelist: any = [];

  agentstatusvalue = 'Select';
  agentmodevalue = 'Select';
  AgentDetailsList: any[];
  agentmodalheight: Number;
  cardHeight: Number = window.innerHeight - 190;
  minDate = new Date(1900, 0, 1);
  maxDate = new Date();
  AgentConfigList: any[];
  formatType: string = "text/plain";
  defaultFormatType:string='text/plain';
  editorOptions = {
    theme: 'vs', language: this.formatType, wordWrap: 'on',scrollBeyondLastLine: false
};
  screeHeightforinput = window.innerHeight - 379;
  configjson: any = "";
  configid: any = "";
  agentupdate: boolean;
  AgentConfigListBackUp: any[];
  filterpipelinelist = <any>[];
  filterpipelinebackuplist = <any>[];
  isLoadingFilteredValue: boolean;
  reactiveFormPipelineFilter: FormGroup;
  configguids: string = '';
  configagentid: string = '';
  configpipelinedisplayname: string = '';
  configentitydisplayname: string = '';
  isselectedpipeline: boolean = false;
  configagentapikey: string = "";
  isLoadingroutes: boolean;
  RouteNameList: any[];
  selectedrouteId: any;
  selectedrouteDisplayName: any;
  selectedrouteuniqueid: any;
  configstatus: any;
  editConfigLockbtn: any;
  isConfigKeysSelected: boolean = false;
  isConfigPopupOpened: boolean = false;
  private destroy$ = new Subject<void>();
  private tabChangeSubscription: Subscription;
  private componentName = 'agent'; // This component's display name
  private isActiveTab = true; // Track if this component's tab is active
  private modalWasOpen = false; // Track if modal was open when tab became inactive
  private currentModalRefs: any[] = []; // Track all modal references (including nested ConfigComponent modals)

  editorInit(editor: any) {
      if (this.configjson) {
        if (this.configjson.startsWith("<")) {
          this.formatType = "xml";
        } else if (this.configjson.startsWith("{")) {
          this.formatType = "json";
        }
        if(this.defaultFormatType!=this.formatType){
          this.defaultFormatType=this.formatType;
        this.editorOptions = {
          ...this.editorOptions,
          language: this.formatType
        };
      }
      }
  }

  constructor(private service: CommonService, private _fb: FormBuilder, private ngxUiLoaderService: NgxUiLoaderService, private toastr: ToastrService, private modalService: NgbModal, private activeModal: NgbActiveModal, private router: Router, private tabChangeService: TabChangeService, private modalTabVisibility: ModalTabVisibilityService) {
    this.reactiveFormagent = _fb.group({ agentname: '' });
    this.reactiveFormagenttypedl = _fb.group({ agentnamedl: '' });
    this.reactiveFormmodetype = _fb.group({ modename: '' });
    this.reactiveFormagentstatustype = _fb.group({ agentstatusname: '' });
    this.reactiveFormPipelineFilter = _fb.group({ filterpipeline: '' });
    this.reactiveFormagentstagetype = _fb.group({ stagename: '' });
    this.reactiveFormmodeagent = _fb.group({ agentmode: '' });
    this.reactiveFormtypeagent = _fb.group({ agenttype: '' });
    this.reactiveFormtypepipeline = _fb.group({ pipeline: '' });
    this.agenttypelist = this.agenttypeAlllist;

  }

  registerMonacoCustomTheme() {
    monaco.editor.defineTheme("myCustomTheme", {
      base: "vs", // can also be vs or hc-black
      inherit: true, // can also be false to completely replace the builtin rules
      rules: [
        {
          token: "comment",
          foreground: "ffa500",
          fontStyle: "italic underline"
        }, {
          token: "comment.js",
          foreground: "008800",
          fontStyle: "bold"
        }, {
          token: "comment.css",
          foreground: "0000ff"
        }, // will inherit fontStyle from `comment` above
      ],
      colors: {}
    });
  }
  pagerolepermisions: any = [];
  isflasgSize: Subscription;


  async ngOnInit() {
    this.isflasgSize = this.service.ConfigJsonFlag.subscribe(data => {
      if (this.service.configModalOpening) return;
      const currentModule = this.router.url.split('/')[2];
      if (data["module"] == currentModule) {
        this.service.configModalOpening = true;
        if (this.service.configDetails.operation == "Add") {
          this.openconfigpopup("big", 'create', '','configKeys')
        }
        else {
          this.openconfigpopup("big", 'Edit', this.service.configDetails,'')
        }
      }
    })
    this.GetAgentTypes();
    const menuid = JSON.parse(sessionStorage.getItem('rolewithmenus')).find(x => x.RoleName == sessionStorage.getItem('SelectedUserRole')).menuslist.find(y => y.MenuName == 'agents').MenuId;
    const actionitems = JSON.parse(sessionStorage.getItem('rolewithmenus')).find(x => x.RoleName == sessionStorage.getItem('SelectedUserRole')).menuslist.filter(y => y.ParentMenuId == menuid);
    actionitems.forEach(element => {
      this.pagerolepermisions[element.MenuName] = true;
    });
    this.getagenttypedllist('agenttype');
    this.reactiveFormagenttypedl.patchValue(this.agenttypeAlllist);
    
    // Subscribe to tab changes
    this.tabChangeSubscription = this.tabChangeService.tabChange$
      .pipe(takeUntil(this.destroy$))
      .subscribe((activeTabName: string) => {
        const wasActive = this.isActiveTab;
        this.isActiveTab = (activeTabName.toLowerCase() === this.componentName.toLowerCase());
        
        if (wasActive && !this.isActiveTab) {
          // Tab became inactive - hide modals but remember they were open
          // Use setTimeout to ensure DOM is ready
          setTimeout(() => {
            this.hideModals();
          }, 0);
        } else if (!wasActive && this.isActiveTab) {
          // Tab became active - hide foreign modals, then restore ours
          setTimeout(() => {
            this.modalTabVisibility.hideForeignOwnedModals('data-agent-modal');
            this.showModals();
            this.applyPendingAgentSearchById();
          }, 0);
        }
      });

    this.applyPendingAgentSearchById();
  }

  /** Deep-link from create Agent Info card: search by agent GUID. */
  private applyPendingAgentSearchById(): void {
    const agentId = this.service.getPendingAgentSearchAgentId();
    if (!agentId) {
      return;
    }
    this.service.clearPendingAgentSearchAgentId();
    this.selectedAgentguid = agentId;
    this.reactiveFormagent.patchValue({ agentname: agentId });
    this.GetAgentsDataSearch();
  }

  selectedAgent(data) {
    this.selectedAgentguid = data.id;
    this.selectedAgentName = data.name;
    this.GetAgentsDataSearch();
  }
  getAgentNames(event: any) {
    var val = event;
    if (val) {
      this.isLoadingagent = true;

      var apiname = "api/Agents/GetByDisplayName?name=" + val + '&agentid=0&type=&filterflag=true';
      this.service.getapiurl(apiname).subscribe({
        next: data => {
          if ((data['status'] && data['statusText']) || data['statusText'] === "Unknown Error") {
            this.ngxUiLoaderService.stop();
            this.toastr.error("Something Went Wrong!", "", { timeOut: 4000, positionClass: 'toast-bottom-right' });
          }
          else {
            this.AgentNameList = data as any[];
            this.AgentNameList = this.service.transformAlphabetically(this.AgentNameList, 'displayname');
            this.AgentNameList.map(obj => obj.displayname = `${obj.displayname} ${'('} ${obj.id} ${')'} ${'('} ${obj.apikey} ${')'}`);
            this.isLoadingagent = false;
            if (data.length == 0) {
              this.notfounddata = true;
            }
            else {
              this.notfounddata = false;
            }
          }
        },
        error: error => {
          this.isLoadingagent = false;
          this.notfounddata = true;
        }
      });
    }
  }
  searchAgentNameCleared() {
    this.isLoadingagent = false;
    this.AgentNameList = [];
    this.selectedAgentguid = '';
    this.notfounddata = false;
    this.AgentDetailsList = [];
    this.reactiveFormagent.reset();
  }

  GetAgentTypes() {
    var apiname = "api/Lookup/GetMessageType?lookuptype=agenttype";
    this.service.getapiurl(apiname).subscribe({
      next: data => {
        this.agenttypelistdropdown = data as any[];
        this.agenttypelistdropdown = this.agenttypelistdropdown.filter(ele => ele.toLowerCase() != "processor");
      },
    });
  }
  GetAgentsDataSearch() {
    this.ngxUiLoaderService.start();
    var agentObj = {
      id: this.selectedAgentguid ? this.selectedAgentguid : "",
      type: this.agenttype == "Select" ? "" : this.agenttype,
      status: this.agentstatusvalue == "Select" ? "" : this.agentstatusvalue.toLowerCase(),
      Mode: this.agentmodevalue == "Select" ? "" : this.agentmodevalue,
      pipelineuniqueid: this.selectedrouteuniqueid ? this.selectedrouteuniqueid : 0
    };
    var apiname = "api/Agents/GetAgentSearch";
    this.service.postapi(apiname, agentObj).then(data => {
      if (data) {
        this.AgentDetailsList = data as any[];
        if (this.AgentDetailsList.length == 0) {
          this.toastr.warning("No results found!!", "", {
            timeOut: 4000,
            positionClass: 'toast-bottom-right'
          });
        }
        if (this.AgentDetailsList.length > 0) {
          this.AgentDetailsList.forEach(ele => {
            if (ele["Mode"] !== "") {
              ele['Mode'] = this.agentmodelist.find(x => x.value.toLowerCase() == ele['Mode'].toLowerCase()).name;
            }
            if (ele["Stage"] !== "") {
              ele['Stage'] = this.agentstagelist.find(x => x.value.toLowerCase() == ele['Stage'].toLowerCase()).name;
            }
          })
        }

        this.ngxUiLoaderService.stop();
      }
    }
    ), error => {
      this.ngxUiLoaderService.stop();
      this.toastr.error("Something Went Wrong!", "", { timeOut: 4000, positionClass: 'toast-bottom-right' })
    };
  }
  reset() {
    this.reactiveFormagent.reset();
    this.reactiveFormagenttypedl.reset();
    this.reactiveFormagentstatustype.reset();
    this.reactiveFormmodetype.reset();
    this.selectedAgentName = "";
    this.agentmodevalue = "Select";
    this.agentstatusvalue = "Select";
    this.agenttype = "Select";
    this.AgentDetailsList = [];
    this.selectedAgentguid = "";
    this.reactiveFormagenttypedl.setValue({ agentnamedl: '' });
    this.reactiveFormagenttypedl.patchValue(this.agenttypeAlllist);
    this.reactiveFormagentstatustype.setValue({ agentstatusname: '' });
    this.reactiveFormagentstatustype.patchValue(this.agentstagelist);
    this.reactiveFormmodetype.setValue({ modename: '' });
    this.reactiveFormmodetype.patchValue(this.agentmodelist);
    this.reactiveFormtypepipeline.reset();
    this.selectedrouteId = '';
    this.selectedrouteDisplayName = '';
    this.selectedrouteuniqueid = '';
    this.RouteNameList = [];
    this.isConfigKeysSelected = false;
    this.isConfigPopupOpened = false;
  }
  agentObj: any;
  agenttitle: any;

  onConfigurationKeysSelected() {
    this.isConfigKeysSelected = true;
  }

  openaddoreditagent(data, modal) {
    this.ngxUiLoaderService.start();
    this.reactiveFormmodeagent.reset();
    this.getagenttypedllist('agenttype');
    this.reactiveFormagentstagetype.reset();
    this.reactiveFormmodeagent.setValue({ agentmode: '' });
    this.reactiveFormagentstagetype.setValue({ stagename: '' });
    this.reactiveFormtypeagent.reset();
    this.reactiveFormtypeagent.setValue({ agenttype: '' });
    if (data) {
      if (data.Stage) {
        data.Stage = this.agentstagelist.find(x => x.value.toLowerCase() == data.Stage.toLowerCase()).name;
        this.reactiveFormagentstagetype.patchValue({
          stagename: this.agentstagelist.find(x => x.value.toLowerCase() == data.Stage.toLowerCase()).name
        });
      }
      if (data.Mode) {
        data.Mode = this.agentmodelist.find(x => x.value.toLowerCase() == data.Mode.toLowerCase()).name;
        this.reactiveFormmodeagent.patchValue({
          agentmode: this.agentmodelist.find(x => x.value.toLowerCase() == data.Mode.toLowerCase()).name
        })
      }
      if (data.type) {
        this.reactiveFormtypeagent.patchValue({ agenttype: data.type });
      }
      this.agentObj = JSON.parse(JSON.stringify(data));

      // this.agentObj=data;
      this.agenttitle = "Edit Agent";
      this.agentmodalheight = window.innerHeight - 74;
      this.agentupdate = true;
      this.getcoreconfigforagent();
    }
    else {
      this.agenttitle = "Add Agent";
      this.agentmodalheight = window.innerHeight - 385;
      this.agentObj = {
        id: uuidv4().toUpperCase(),
        name: '',
        type: '',
        apikey: uuidv4().toUpperCase(),
        Version: '',
        HeartbeatUrl: '',
        Ownerentity: '',
        description: '',
        Stage: '',
        Mode: '',
        Releasedate: new Date(),
        Livedate: new Date(),
        modifierid: JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['userid']
      }
    }
    // Open modal with appropriate windowClass based on update/add mode
    const windowClass = this.agentupdate ? "agentmodaledit" : "agentmodaladd";
    const modalRef = this.modalService.open(modal, { windowClass: windowClass, backdrop: 'static', keyboard: false });
    this.currentModalRefs.push(modalRef); // Track modal reference
    
    // Handle modal close (both success and dismiss)
    modalRef.result.then((result) => { 
      this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== modalRef); // Remove on close
      this.modalWasOpen = false;
    }).catch(() => {
      this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== modalRef); // Remove on dismiss
      this.modalWasOpen = false;
    });
    
    this.modalTabVisibility.tagOwned('data-agent-modal', windowClass);
    this.modalWasOpen = true;

    this.ngxUiLoaderService.stop();
  }
  closeagentpopup(c) {
    c('close modal');
    // Mark that modal is now closed
    this.modalWasOpen = false;
    // Remove from array if it exists
    if (this.currentModalRefs && this.currentModalRefs.length > 0) {
      // Find and remove the main agent modal (the one being closed)
      this.currentModalRefs = this.currentModalRefs.filter(ref => {
        try {
          // Try to close it if it's still open
          if (ref) {
            ref.close();
          }
          return false; // Remove from array
        } catch (e) {
          return false; // Remove from array even if already closed
        }
      });
    }
    this.clearvalue();
    this.getagenttypedllist('agenttype');
    this.GetAgentsDataSearch();
  }

  clearvalue() {
    this.AgentDetailsList = [];
    this.agentupdate = false;
    this.configid = "";
    this.configjson = "";
    this.AgentConfigList = [];
    this.agentObj = "";
    this.AgentConfigListBackUp = [];
    this.filterpipelinebackuplist = [];
    this.filterpipelinelist = [];
    this.configguids = "";
    this.configagentid = "";
    this.configentitydisplayname = "";
    this.configpipelinedisplayname = "";
    this.isselectedpipeline = false;
    this.reactiveFormPipelineFilter.reset();
    this.configagentapikey = "";
    this.configstatus = "";
  }
  getcoreconfigforagent() {
    this.ngxUiLoaderService.start();
    var dataPost = {
      agentid: this.agentObj.id,
      filtertype: 'Agent'
    };
    this.service.postapi("api/CoreConfig/GetCoreConfig", dataPost).then(Response => {
      if (Response) {
        if ((Response['status'] && Response['statusText']) || Response['statusText'] === "Unknown Error") {
          this.ngxUiLoaderService.stop();
          this.toastr.error("Something Went Wrong!", "", { timeOut: 4000, positionClass: 'toast-bottom-right' });
        }
        else {
          this.AgentConfigList = Response as any[];
          this.AgentConfigListBackUp = this.AgentConfigList;
          if (this.AgentConfigList.length > 0) {
            this.AgentConfigList.forEach(ele => {
              if (ele.pipelinedisplayname) {
                let obj = {
                  name: ele.pipelinedisplayname,
                  displayname: `${ele.pipelinedisplayname}(${ele.guids})`,
                  id: ele.guids
                }
                this.filterpipelinelist.push(obj);
              }

            });
            if (this.filterpipelinelist.length > 0) {
              this.filterpipelinelist = [...new Map(this.filterpipelinelist.map(item =>
                [item["id"], item])).values()];
              this.filterpipelinebackuplist = this.filterpipelinelist;
            }
            this.reactiveFormPipelineFilter.setValue({ "filterpipeline": "" });
            this.ngxUiLoaderService.stop();
          }
        }
      }
    }, error => {
      this.ngxUiLoaderService.stop();
      this.toastr.error("Something Went Wrong!", "", { timeOut: 4000, positionClass: 'toast-bottom-right' });
    })
  }

  editconfigjson(data, array) {
    array.forEach(ele => {
      ele["active"] = false;
    })
    if (data.json != "{}" && data.json) {
      data["active"] = true;
     
      // Existing: bound raw/minified JSON from DB, which Monaco showed as a single line
      // this.configjson = data.json;
      // Pretty-print valid JSON for readable Monaco display (same approach as Processor screen); keep original on parse failure (e.g. XML)
      try {
        this.configjson = JSON.stringify(JSON.parse(data.json), null, 2);
      } catch {
        this.configjson = data.json;
      }
    }
    this.configagentid = data.agentid;
    this.configagentapikey = data.agentapikey;
    this.configid = data.configid;
    this.configguids = data.guids;
    this.editConfigLockbtn = data.isPipelineLocked;
    this.configpipelinedisplayname = data.pipelinedisplayname;
    this.configentitydisplayname = data.entitydisplayname;
    this.configstatus = data.status;
  }
  saveagent(modifystatus: boolean, modal?: any, closeAfterSave: boolean = false) {
      this.agentObj.Stage = this.agentObj.Stage != ""? this.agentstagelist.find(x => x.value.toLowerCase() == this.agentObj.Stage.toLowerCase()).value : this.agentObj.Stage;
      this.agentObj.Mode = this.agentObj.Mode != ""? this.agentmodelist.find(x => x.value.toLowerCase() == this.agentObj.Mode.toLowerCase()).value : this.agentObj.Mode;
    if (modifystatus) {
      this.agentObj.status = this.agentObj.status == 'active' ? 'passive' : 'active';
    }
    if (this.agentObj.id && this.agentObj.apikey && this.agentObj.name && this.agentObj.type) {
      this.ngxUiLoaderService.start();
      this.agentObj["modifierid"] = JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['userid'];
      this.service.postapi("api/Agents/SaveAgent", this.agentObj).then(response => {
        if (response) {
          if ((response['status'] && response['statusText']) || response['statusText'] === "Unknown Error") {
            this.ngxUiLoaderService.stop();
            this.toastr.error("Something Went Wrong!", "", { timeOut: 4000, positionClass: 'toast-bottom-right' });
          }
          else {
            this.GetAgentsDataSearch();

            if (modifystatus) {
              if (this.agentObj.status == 'active') {
                this.ngxUiLoaderService.stop();
                this.toastr.success("Agent Activated Successfully", "", { timeOut: 500, positionClass: 'toast-bottom-right' });
              }
              else {
                this.ngxUiLoaderService.stop();
                this.toastr.success("Agent Disabled Successfully", "", { timeOut: 500, positionClass: 'toast-bottom-right' });
              }
            }
            else if (this.agentupdate) {

              this.ngxUiLoaderService.stop();
              this.toastr.success("Agent Updated Successfully", "", { timeOut: 500, positionClass: 'toast-bottom-right' });
              if (closeAfterSave && modal) {
                this.closeagentpopup(modal);
              }
            }
            else {
              this.ngxUiLoaderService.stop();
              this.toastr.success("Agent Created Successfully with Agent ID " + this.agentObj.id.toUpperCase(), "", { timeOut: 500, positionClass: 'toast-bottom-right' });
              if (closeAfterSave && modal) {
                this.closeagentpopup(modal);
              }
            }
          }
        }
        else {
          this.ngxUiLoaderService.stop();
        }
      }), error => {
        this.ngxUiLoaderService.stop();
        this.toastr.error("Something Went Wrong!", "", { timeOut: 4000, positionClass: 'toast-bottom-right' })
      }
    }
    else {
      this.toastr.warning("Please enter the required fields", "", { timeOut: 4000, positionClass: 'toast-bottom-right' });
    }
  }

  copyToClip(event: any, message) {
    if (event != '') {
      copyToClipboard(event);
      this.toastr.success(message + " " + 'Copied', "", {
        timeOut: 500,
        positionClass: 'toast-bottom-right'
      });
    }
  }
  buildtitleforagent() {
    if (this.agentupdate) {
      return 'Update Agent';
    }
    else {
      return 'Add Agent'
    }
  }
  openAuditPopUp(uniqueid: any, agentguid: any, agentname: any) {

    if (uniqueid != '' && agentguid != '') {
      const auditDataToModal = {
        id: uniqueid,
        title: agentname,
        context: "Agent",
        type: "ID",
        guid: agentguid,
        userid: JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['userid']
      };

      const modalRef = this.modalService.open(NewauditComponent,
        { windowClass: "myCustomModalClass", backdrop: 'static', keyboard: false });
      modalRef.componentInstance.inputDataInModalComponent = auditDataToModal;
      this.currentModalRefs.push(modalRef); // Track modal reference
      
      modalRef.result.then(() => {
        this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== modalRef);
      }, (reason) => {
        this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== modalRef);
      });
      
      this.modalTabVisibility.tagOwned('data-agent-audit-modal', 'myCustomModalClass');
      this.modalWasOpen = true;
    }

  }
  onDataChange(newdate, obj) {
    const currentTimeObj = moment();
    const date = moment(newdate).add({ hours: 5, minutes: 30, seconds: 0 });
    this.agentObj[obj] = date.toDate();
  }



  selectedagenttypedlevent(item) {
    this.agenttype = item.displayname;
  }
  CleareAgentdl(event) {
    this.agenttype = '';
  }
  agenttypelistdropdown: any = [];
  agenttypeAlllist: any = [];
  isLoadingagenttypedl: boolean = false;
  getagenttypedllist(event: any) {
    this.isLoadingagenttypedl = true;
    if (event !== 'agenttype') {
      if (event == undefined) {
        this.agenttypelist = this.agenttypeAlllist;
      }
      else {
        this.agenttypelist = this.agenttypeAlllist.filter(t => t.displayname.toLowerCase().includes(event.toLowerCase()));
      }
      if (this.agenttypelist.length == 0) {
        this.notfounddata = true;
      } else {
        this.notfounddata = false;
      }
      this.isLoadingagenttypedl = false;
    }
    else {

      this.service.getapiurl("api/Lookup/GetMessageType?lookuptype=agenttype").subscribe({
        next: data => {
          this.agenttypeAlllist = [];
          // this.agenttypelistdropdown = data.filter(ele => ele.toLowerCase() != "processor");
          data.forEach(element => {
            if (element.toLowerCase() != "processor".toLowerCase()) {
              this.agenttypeAlllist.push({ displayname: element });
            }
          });
          this.agenttypelist = this.agenttypeAlllist;
          this.isLoadingagenttypedl = false;
          if (this.agenttypelist.length == 0) {
            this.notfounddata = true;
          } else {
            this.notfounddata = false;
          }
        },
        error: error => {
          this.isLoadingagenttypedl = false;
          this.notfounddata = true;
        }
      });
    }


  }


  keyword = "name";


  async selectagentstatusEvent(item) {
    this.agentstatusvalue = item.name;
  }

  clearedagentstatus(item) {
    this.agentstatusvalue = '';
  }

  public agentstagelist = [
    {
      name: 'Live',
      value: 'Live'.toLocaleLowerCase()
    },
    {
      name: 'Test',
      value: 'Test'.toLocaleLowerCase()
    }
  ];

  public agentstatus = [
    {
      name: 'Active',
    },
    {
      name: 'Passive',
    }
  ];
  onagentstatusFocused(e) {
    this.agentstatus = [
      {
        name: 'Active',
      },
      {
        name: 'Passive',
      }
    ];

  }



  async selectmodeEvent(item) {
    this.agentmodevalue = item.name;
  }

  clearednodestatus(item) {
    this.agentmodevalue = '';
  }

  public agentmodelist = [
    {
      name: 'Live',
      value: 'Live'.toLocaleLowerCase()
    },
    {
      name: 'Stage',
      value: 'Stage'.toLocaleLowerCase()
    },
    {
      name: 'Test',
      value: 'Test'.toLocaleLowerCase()
    }
  ];
  onmodeFocused(e) {
    this.agentmodelist = [
      {
        name: 'Live',
        value: 'Live'.toLocaleLowerCase()
      },
      {
        name: 'Stage',
        value: 'Stage'.toLocaleLowerCase()
      },
      {
        name: 'Test',
        value: 'Test'.toLocaleLowerCase()
      }
    ];

  }
  openconfigpopup(isflag: string, type: string, item, source: string) {
    if (source === 'configKeys') {
      this.isConfigPopupOpened = true;
    }
    this.ngxUiLoaderService.start();
    if (isflag == "small") {
      let data = {};
      if (type == "create") {
        data = {
          pipelineid: '',
          pipelinedisplayname: '',
          entitydisplayname: '',
          editjson: "small",
          type: "create",
          configlist: this.AgentConfigList,
          disablepipeline: false,
          agentdisplayname: this.agentObj.name,
          agentid: this.agentObj.id,
          disableagent: true,
          guidtype: '',
          agentuniqueid: this.agentObj.UniqueID
        }
      }
      else {
        data["configid"] = item.configid;
        data["agentid"] = item.agentid;
        data["json"] = item.json;
        if (item["guids"] && item["pipelinedisplayname"]) {
          data["pipelineid"] = item.guids;
          data["pipelinedisplayname"] = item.pipelinedisplayname;
          data["guidtype"] = "Pipeline";
        }
        else if (item["guids"] && item["entitydisplayname"]) {
          data["guids"] = item["guids"];
          data["entitydisplayname"] = item["entitydisplayname"];
          data["guidtype"] = "Entity";
          data["entitytype"] = item["entitytype"];
          data["entityaccounttype"] = item["entityaccounttype"];
          data["entitydeploymentkey"] = item["entitydeploymentkey"];
          data["entityaddress1"] = item["entityaddress1"];
          data["entityaddress2"] = item["entityaddress2"];
          data["entitycity"] = item["entitycity"];
          data["entitystate"] = item["entitystate"];
          data["entityzip"] = item["entityzip"];
        }
        else if (item["guids"]) {
          data["guids"] = item["guids"];
          data["guidtype"] = "Custom";
        }
        else {
          data["guids"] = '';
        }
        data["agentdisplayname"] = item.agentdisplayname;
        data["disableagent"] = true;
        data["editjson"] = "small";
        data["type"] = "Edit";
        data["disablepipeline"] = false;
        data["status"] = item.status;
        data["agentuniqueid"] = this.agentObj.UniqueID;
        data["agentapikey"] = item.agentapikey
      }

      const modalRef = this.modalService.open(ConfigComponent,
        { windowClass: "modalConfigJSONagentsmall", backdrop: 'static', keyboard: false });
      this.currentModalRefs.push(modalRef); // Track modal reference
      modalRef.componentInstance.inputDataInModalComponent = data;
      modalRef.result.then((data) => {
        this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== modalRef); // Remove on close
        if (data == "refresh") {
          this.ngxUiLoaderService.start();
          this.getcoreconfigforagent();
        }
      }).catch(() => {
        this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== modalRef); // Remove on dismiss
      });
      
      this.modalTabVisibility.tagOwned('data-agent-modal', 'modalConfigJSONagentsmall');
      this.modalWasOpen = true;
    } else {
      let data = {
        editjson: "big",
        type: type
      }
      if (type != "create" && item == '') {
        data["configid"] = this.configid;
        data["agentid"] = this.configagentid;
        data["json"] = this.configjson;
        data["guids"] = this.configguids ? this.configguids : ''
        data["status"] = this.configstatus;
      }
      else if (type != "create" && item != '') {
        data["configid"] = item.configid;
        data["agentid"] = item.agentid;
        data["json"] = item.json;
        data["guids"] = item.guids;
        data["status"] = item.status;
      }
      data["agentuniqueid"] = this.agentObj.UniqueID;
      data["agentapikey"] = item.agentapikey ? item.agentapikey : this.configagentapikey
      const modalRef = this.modalService.open(ConfigComponent,
        { windowClass: "modalConfigJSONagentbig", backdrop: 'static', keyboard: false });
      this.currentModalRefs.push(modalRef); // Track modal reference
      modalRef.componentInstance.inputDataInModalComponent = data;
      modalRef.result.then((data) => {
        this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== modalRef); // Remove on close
        this.service.configModalOpening = false;
        if (data === "refresh" || (data === undefined && source === 'configKeys')) {       
          this.ngxUiLoaderService.start();
          this.configagentid = "";
          this.configid = "";
          this.configjson = "";
          this.configstatus = "";
          this.configagentapikey = "";
          this.configentitydisplayname="";
          this.configguids="";
          this.configpipelinedisplayname="";
          this.getcoreconfigforagent();
          this.ngxUiLoaderService.stop();
        }
      }).catch(() => {
        this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== modalRef); // Remove on dismiss
        this.service.configModalOpening = false;
      });
      
      this.modalTabVisibility.tagOwned('data-agent-modal', 'modalConfigJSONagentbig');
      this.modalWasOpen = true;
    }
    this.ngxUiLoaderService.stop();
  }

  getFilteredValues(event) {
    if (event) {
      this.isLoadingFilteredValue = true;
      this.ngxUiLoaderService.start();
      if (this.filterpipelinelist.length == 0) {
        this.filterpipelinelist = this.filterpipelinebackuplist;
      }
      let isfound = false;
      const regexExp = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;
      if (regexExp.test(event)) {
        isfound = true;
        this.filterpipelinelist = this.filterpipelinelist.filter(x => x.id == event);
      }
      else {
        isfound = true;
        this.filterpipelinelist = this.filterpipelinelist.filter(x => x.name.toLowerCase().includes(event.toLowerCase()));
      }
      if (isfound) {
        this.configagentid = "";
        this.configguids = "";
        this.configid = "";
        this.configjson = "";
        this.configstatus = '';
        if (this.filterpipelinelist.length == 0) {
          this.notfounddata = true;
        }
        this.isLoadingFilteredValue = false;
      }
      this.ngxUiLoaderService.stop();
    }
  }
  selectedFilteredValues(item) {
    if (item) {
      this.isselectedpipeline = true;
      this.AgentConfigList = this.AgentConfigList.filter(x => (x.guids != "") && (x.guids == item.id));
    }
  }
  searchFilteredValuesCleared(item) {
    if (this.AgentConfigList.length != this.AgentConfigListBackUp.length) {
      this.configagentid = "";
      this.configguids = "";
      this.configid = "";
      this.configjson = "";
      this.configstatus = '';
      this.isselectedpipeline = false;
      this.AgentConfigList = this.AgentConfigListBackUp;
    }
    this.filterpipelinelist = this.filterpipelinebackuplist;
    this.notfounddata = false;
    this.reactiveFormPipelineFilter.reset();
    this.reactiveFormPipelineFilter.setValue({ "filterpipeline": "" })
  }
  selectstageEvent(event) {
    this.agentObj.Stage = event.name;
  }
  clearedstatge() {
    this.agentObj.Stage = "";
  }
  selectagentmode(event) {
    this.agentObj.Mode = event.name;
  }
  clearedagentmode() {
    this.agentObj.Mode = "";
  }
  selectedagenttypeevent(item) {
    this.agentObj.type = item.displayname;
  }
  CleareAgentType() {
    this.agentObj.type = "";
  }
  getRouteName(event: any) {
    var val = event;
    if (val) {
      this.isLoadingroutes = true;
      var apiname = "api/Routes/GetByDisplayName?name=" + val + "&version=0";
      this.service.getapiurl(apiname).subscribe({
        next: data => {
          this.RouteNameList = data as any[];
          this.RouteNameList.map(obj => obj.displayname = `${obj.displayname}  ${'(' + obj.id + ')(VA-'+obj.UniqueID+')'}`);
          this.isLoadingroutes = false;
          if (data.length == 0) {
            this.notfounddata = true;
          } else {
            this.notfounddata = false;
          }
        },
        error: error => {
          this.isLoadingroutes = false;
          this.notfounddata = true;
        }
      });
    }
  }
  selectedRoute(item) {
    this.selectedrouteId = item.id;
    this.selectedrouteDisplayName = item.displayname;
    this.selectedrouteuniqueid = item.UniqueID;
    this.GetAgentsDataSearch();
  }
  searchRouteNameCleared(event) {
    this.isLoadingroutes = false;
    this.RouteNameList = [];
    this.selectedrouteId = '';
    this.selectedrouteDisplayName = '';
    this.notfounddata = false;
  }
  ngOnDestroy() {
    // Close all open modals when component is destroyed
    if (this.currentModalRefs && this.currentModalRefs.length > 0) {
      this.currentModalRefs.forEach(modalRef => {
        if (modalRef) {
          try {
            modalRef.close();
          } catch (e) {
            // Modal might already be closed, ignore error
          }
        }
      });
      this.currentModalRefs = [];
    }
    
    this.destroy$.next();
    this.destroy$.complete();
    if (this.tabChangeSubscription) {
      this.tabChangeSubscription.unsubscribe();
    }
    if (this.isflasgSize) {
      this.isflasgSize.unsubscribe();
    }
  }
  
  private hideModals() {
    const result = this.modalTabVisibility.hideOwned('data-agent-modal', {
      hasOpenRefs: this.currentModalRefs?.length > 0,
      windowClasses: ['agentmodaledit', 'agentmodaladd', 'modalConfig', 'modalConfigJSONagentsmall', 'modalConfigJSONagentbig', 'modalConfigJSONagent'],
      nestedOwnerAttrs: ['data-agent-audit-modal'],
    });
    this.modalWasOpen = result.modalWasOpen;
  }

  private showModals() {
    this.modalTabVisibility.showOwned('data-agent-modal', {
      modalWasOpen: this.modalWasOpen,
      hasOpenRefs: this.currentModalRefs?.length > 0,
      windowClasses: ['agentmodaledit', 'agentmodaladd', 'modalConfig', 'modalConfigJSONagentsmall', 'modalConfigJSONagentbig', 'modalConfigJSONagent'],
      nestedOwnerAttrs: ['data-agent-audit-modal'],
    });
  }
  getstringRoute(value) {
    let names = value.split("(")
    value = `${names[0]} <br>(${names[1]} <br>(${names[2]}`
    return value
  }

}



